import { createIcon } from './create-icon';
import React from 'react';
import './icon-more-options.scss';

export const IconMoreOptions = createIcon(<div className="icon-more-options" />);
